import { UNIQUE_FIELDS } from "./magic-field-types";

export default function isUniqueField(fieldType) {
    return UNIQUE_FIELDS.includes(fieldType);
}